var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "people-24px-2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.733,
    height: 44.733,
    viewBox: "0 0 44.733 44.733",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M0,0H44.733V44.733H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M28.946,16.143a5.572,5.572,0,1,0-5.589-5.572A5.557,5.557,0,0,0,28.946,16.143Zm-14.9,0a5.572,5.572,0,1,0-5.589-5.572A5.557,5.557,0,0,0,14.041,16.143Zm0,3.714C9.7,19.857,1,22.03,1,26.357V31H27.083V26.357C27.083,22.03,18.382,19.857,14.041,19.857Zm14.9,0c-.54,0-1.155.037-1.807.093a7.832,7.832,0,0,1,3.67,6.407V31H41.987V26.357C41.987,22.03,33.286,19.857,28.946,19.857Z",
    transform: "translate(0.873 4.366)",
    fill: "#212121"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewer);
export default __webpack_public_path__ + "static/media/viewer.972068e8.svg";
export { ForwardRef as ReactComponent };